import React from "react";
import { Styled } from './styled';
import Quote from "~/components/quote";
import {SellMoreScreen} from "~common/sell-more-screen";

const Autoinformator = () => {
  return (
    <>
      <Styled.Container>
        <Styled.Title>
          Автоинформатор
        </Styled.Title>
        <Styled.Text>
          Автоинформатор — это модуль, который обзванивает клиентов по списку и воспроизводит голосовое сообщение. Если после аудиосообщения у клиента остались вопросы, он нажимает клавишу и звонок переводится на оператора.
          <Styled.Indent/>
          Вот истории наших клиентов:
        </Styled.Text>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Анвар, владелец онлайн-школы</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>Нам нужно было перенести время вебинара за день до старта и срочно предупредить об этом ~100 клиентов. Все волновались, мы запускали новый курс, был риск не собрать аудиторию и не сделать плановый объем продаж.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>В итоге мы записали аудио-сообщение с новой датой вебинара, загрузили его вместе со списком телефонов в автоинформатор и запустили обзвон.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Результат: не смотря на смену даты к вебинару присоединились 74 зрителя, что соответствовало нашим прогнозам. Мы не получили ни одного гневного сообщения, что кто-то был не в курсе переноса времени.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Манзура, владелица стоматологической клиники</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>Два раза в год мы проводим акцию — скидка 50% на профессиональную чистку. Клиентов уведомляем через автоинформатор, т. к. ресурса администратора на обзвон нет.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>В аудиосообщении рассказываем про условия акции, кто заинтересовался — нажимает «1» и звонок переводится на администратора, который уже записывает на процедуру. Из тех, кто поднял трубку, от 23% до 35% записываются на чистку, что для нас очень хороший результат. Через e-mail рассылку приходило не более 3%.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
      </Styled.Container>
      <Styled.SelMore className="onlinepbx__sel__more">
        <SellMoreScreen />
      </Styled.SelMore>
    </>
  )
}

export default Autoinformator
